<template>
  <div class="d-flex align-center justify-center flex-column">
    <div class="auth-reset-password-success-icon-container d-flex align-center justify-center mb-8">
     <icon name="lock24" class="auth-reset-password-success-icon"/>
    </div>
    <p class="ma-0 auth-reset-password-title">
      {{ $t('auth.resetPassword.success.title') }}
    </p>
    <p class="auth-reset-password-text mt-5 mb-0">
      {{ $t('auth.resetPassword.success.text') }}
    </p>
    <button
      class="auth-reset-password-login mt-5"
      @click="$router.push( { name: 'Login' } )"
    >
      {{ $t('auth.resetPassword.success.backToLogin') }}
    </button>
  </div>
</template>

<script>
import Icon from '@/assets/icons/Icon.vue'

export default {
  name: 'AuthResetPasswordSuccess',

  components: { Icon },

  data() {
    return {
    }
  }
}
</script>

<style scoped lang="scss">
.auth-reset-password-success-icon-container{
  width: 96px;
  height: 96px;
  background-color: var(--v-background-light-green-base);
  border-radius: 100%;
}

.auth-reset-password-success-icon{
  width: 44px;
  height: 44px;
  color: var(--v-icon-black-base);
}

.auth-reset-password-title {
  color: var(--v-text-primary-base, #19181A);
  text-align: center;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto, sans-serif;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 36px;
}

.auth-reset-password-text {
  color: var(--v-text-primary-base, #19181A);
  text-align: center;
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.auth-reset-password-login {
  color: var(--v-link-primary-text-default-base, #B645EE);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-bottom: 1px solid var(--v-link-primary-border-default-base, #F4E3FD);
  cursor: pointer;
}
</style>
